import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchProgresses(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/project_progress/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchProgress(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/project_progress/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editProgress(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/project_progress", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProgress(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/project_progress", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProgressSalary(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/project_progress/salary", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProgressCost(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/project_progress/cost", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    approveProgress(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/project_progress/approve", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  
    updateProjectDocument(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/projects/progress/documents", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProgressDocument(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/projects/progress/documents", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  }
};
